import arrowUp from "Assets/icons/arrow_up.svg";
import "./scrollToTop.scss";

const ScrollToTop = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <button
      className="scrollToTop"
      onClick={scrollToTop}
      aria-label="Scroll to top"
    >
      <img
        src={arrowUp}
        width={24}
        height={24}
        className="icon"
        alt="Scroll to top"
      />
    </button>
  );
};

export default ScrollToTop;
